import { Injectable } from '@angular/core';
import { ApiService } from 'app/main/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class RatingService {

  constructor(
    private api: ApiService
  ) {

  }

  // rating studente
  async newRating(feedback) {
    return this.api.postRequestPromise(`purchasedsalespackage/ranking/create`, feedback);
  }

  // rating admin
  async getFakeRating(professorId) {
    return this.api.getRequestPromise(`fakeRanking/${professorId}`);
  }
  async putFakeRating(feedback) {
    return this.api.putRequestPromise(`fakeRanking`, feedback);
  }
  async getBoost(professorId) {
    return this.api.getRequestPromise(`boost/${professorId}`);
  }
  async putBoost(feedback) {
    return this.api.putRequestPromise(`boost`, feedback);
  }
}


